import React from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  .bar {
    display: block;
    position: relative;
    width: 28px;
    height: 22px;
  }

  .bar span {
    position: absolute;
    width: 28px;
    height: 4px;
    background: var(--primary-color);
    border-radius: 100px;
    display: inline-block;
    transition: 0.3s ease;
    left: 0;
  }

  .bar span.top {
    top: 0;
  }

  .bar span.middle {
    top: 9px;
  }

  .bar span.bottom {
    bottom: 0;
  }

  &[data-open='true'] .bar span.top {
    transform: rotate(45deg);
    transform-origin: top left;
    width: 30px;
    left: 2px;
  }

  &[data-open='true'] .bar span.bottom {
    transform: rotate(-45deg);
    transform-origin: top left;
    width: 30px;
    bottom: -1px;
  }

  &[data-open='true'] .bar span.middle {
    transform: translateX(-12px);
    opacity: 0;
  }
`;

/**
 * Hamburger menu icon that animates to X when open.
 * Controlled by parent via `open` prop (parent button handles click).
 */
function Menu({ open = false, className }) {
  return (
    <StyledWrapper className={className} data-open={open} aria-hidden>
      <span className="bar">
        <span className="top" />
        <span className="middle" />
        <span className="bottom" />
      </span>
    </StyledWrapper>
  );
}

export default Menu;
